import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import * as icon from '@fortawesome/free-solid-svg-icons';

// Please maintain alphabetical order of icons for sanity sake
export function registerIcons (): void {
	library.add(
		icon.faAngleDown,
		icon.faAngleUp,
		icon.faArrowLeft,
		icon.faArrowsAlt,
		icon.faChalkboardTeacher,
		icon.faChevronDown,
		icon.faChevronUp,
		icon.faClock,
		icon.faDollarSign,
		icon.faEllipsisH,
		icon.faEnvelope,
		icon.faExternalLinkAlt,
		icon.faGraduationCap,
		icon.faHeart,
		icon.faHeartBroken,
		icon.faLandmark,
		icon.faMapMarkerAlt,
		icon.faPrint,
		icon.faQuestionCircle,
		icon.faSearch,
		icon.faTachometerAlt,
		icon.faTh,
		icon.faTimes,
		icon.faTimesCircle,
		icon.faVolumeUp,
		icon.faWifi
	);

	Vue.component('font-awesome-icon', FontAwesomeIcon);
}
